import { IHttpApi } from '@cian/http-api';
import { IFilterNewBuildingsRequest } from '../../types/newBuldings/filters';
import { INewbuildingsData } from '../../types/newBuldings';
import {
  fetchGetNewbuildingsForDeveloperCard,
  TGetNewbuildingsForDeveloperCardResponse,
} from '../../repositories/newbuilding-search/v1/get-newbuildings-for-developer-card';
import { newbuildingMapper, newbuildingCountsMapper } from '../../mappers';
import { assertNotFoundError } from './assert/assertNotFoundError';

export async function getNewBuildings(props: {
  httpApi: IHttpApi;
  parameters: IFilterNewBuildingsRequest;
  subdomain: string;
}): Promise<INewbuildingsData> {
  const response: TGetNewbuildingsForDeveloperCardResponse = await fetchGetNewbuildingsForDeveloperCard({
    httpApi: props.httpApi,
    parameters: props.parameters,
  });

  assertNotFoundError(response);

  const data = response.response;

  return {
    jsonQuery: data.jsonQuery,
    newbuildingCounts: newbuildingCountsMapper(data.newbuildingCounts),
    newbuildings: data.newbuildings.map(item => newbuildingMapper(item)),
  };
}
